/* 絞り込み検索 */
$(function(){
    /* PC用 */
    if (window.matchMedia("(min-width: 668px)").matches) {
        // 簡易絞込を開閉する
        $("#search_content_form .search_movie_box_tag dt").on("click", function(e) {
            e.stopPropagation();
            $(this).next().slideToggle(300);
            $(this).toggleClass("active");

            // 他のドロップダウンリストは閉じる
            $(".search_movie_box_tag dt").not($(this)).next().slideUp(300);
            $(".search_movie_box_tag dt").not($(this)).removeClass("active");
        });
        // ドロップダウンリストがチェックボックスのクリック時に閉じないようにする
        $("#search_content_form .search_movie_box_tag dd").on("click", function(e) {
            e.stopPropagation();
        });
        // 背景クリック時にドロップダウンリストを閉じるようにする
        $("#search_content_form").on("click", function() {
            $(".search_movie_box_tag dd").hide();
            $(".search_movie_box_tag dt").removeClass("active");
        });
        // 詳細絞込の開く・閉じるボタンが押された時
        $("#search_content_form .search_movie_box_btn_more, #search_content_form .search_movie_detail_btn_close").on("click", function() {
            var $wrap = $(".search_movie_detail_wrap");
            var $button = $(".search_movie_box_btn_more");
            if ($wrap.is(":hidden")) {
                $wrap.slideToggle(500);
                $button.addClass("active").find(".pc_only").html('<i class="icon-close"></i>閉じる');
            } else {
                $wrap.slideUp();
                $button.removeClass("active").find(".pc_only").html('<i class="icon-filter"></i>さらに絞り込み');
            }
        });
        // 選択中フィルタの選択済みチェックを外された時
        $('#search_content_form .search_movie_box_filter_list').on('click', '.search_movie_box_filter_remove', function(e) {
            e.preventDefault();
            var id = $(this).data('id');
            $('#' + id).prop('checked', false);
            $('#' + id + '_simple').prop('checked', false);

            refreshSelectedFilter();
        });
    }
    /* スマホ用 */
    else {
        // 詳細絞込
        $(function() {
            var scrollPos;
            // 詳細絞込モーダルを開く
            $("#search_content_form .search_movie_box_btn_more").on("click", function() {
                $(".search_movie_detail_body").css("height", window.innerHeight - 126);
                scrollPos = $(window).scrollTop();
                $("html").addClass("is_fixed");
                $(".search_movie_detail_wrap").fadeToggle(300);
                $(this).toggleClass("active");
            });
            // 詳細絞込モーダルを閉じる
            $("#search_content_form .search_movie_detail_btn_close").click(function () {
                $("html").removeClass("is_fixed");
                $(".search_movie_detail_wrap").fadeOut();
                $(".search_movie_box_btn_more").removeClass("active");
                $(window).scrollTop(scrollPos);
            });
        });
    }

    /* PC/スマホ共通 */
    // チェックボックスがチェックされた時
    $('#search_content_form input[type="checkbox"]').on('click', function(){
        // チェックボックスのチェック状態の同期をとる
        var name = $(this).attr('id');
        if (name.indexOf('_simple_sp') !== -1) {
            name = name.replace('_simple_sp', '');
        }
        if (name.indexOf('_simple') !== -1) {
            name = name.replace('_simple', '');
        }
        $('#' + name).prop('checked', $(this).prop('checked'));
        $('#' + name + '_simple').prop('checked', $(this).prop('checked'));
        $('#' + name + '_simple_sp').prop('checked', $(this).prop('checked'));

        refreshSelectedFilter();

    });
    // すべてをクリアするをクリックした時
    $('#search_content_form .search_movie_box_allclear, #search_content_form .search_movie_detail_btn_clear').on('click', function(e){
        e.preventDefault();
        $('input[type="checkbox"]:checked').prop('checked', false);

        refreshSelectedFilter();
    });

    // 選択中フィルタを再描画
    var refreshSelectedFilter = function() {
        // 選択中フィルタをいったん全削除する
        $('#search_content_form .search_movie_box_filter_item').remove();
        // 選択中フィルタを再描画する
        var selected = false;
        $('#search_content_form .search_movie_detail_wrap input[type="checkbox"]:checked').each(function() {
            selected = true;
            var name = $(this).next().text();
            var id = $(this).attr('id');
            var item = '<li class="search_movie_box_filter_item">' + name + '<a class="search_movie_box_filter_remove" href="#" data-id="' + id + '"></a></li>';
            $('.search_movie_box_filter_list').prepend(item);
        });
        // 1つでもチェックされていたら選択中フィルタを表示させる
        if (selected) {
            $('.search_movie_box_filter').removeClass('force-nodisp');
        } else {
            $('.search_movie_box_filter').addClass('force-nodisp');
        }
    };
});
